import { useEffect } from 'react';
import { useLocalizer } from './useLocalizer';

export const useDocumentTitle = (pageTitle?: string) => {
  const { globalL } = useLocalizer('');
  const baseTitle = globalL('documentTitle');

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const title = pageTitle?.trim();
    document.title = title ? `${title} - ${baseTitle}` : baseTitle;

    return () => {
      if (typeof document !== 'undefined') document.title = baseTitle;
    };
  }, [baseTitle, pageTitle]);
};
